import { d as decode, e as encode } from './built-get-url-variant-a647ef33.js';
import { C as Cookies } from './built-js.cookie-7baadf9c.js';

// @ts-check
/**
 * Append a query string key and value to a URL, if it isn't already there
 * @param {string} url
 * @param {string} key
 * @param {string | boolean | number} value
 * @returns {string} The updated URL
 */

const appendQueryStringToURL = (url, key, value) => {
  const hasQS = url.indexOf('?') > -1;
  const hasQSKey = url.indexOf(key) > -1;

  if (hasQSKey) {
    return;
  }

  return "" + url + (hasQS ? '&' : '?') + key + "=" + value;
};
/**
 * Update a query string in a URL using `history.replaceState`
 * Preserves any `hash` value
 * If `value` is ommitted, removes that key from the query string
 * @param {string} key
 * @param {string | boolean | number} [value]
 */

const updateQueryString = (key, value) => {
  const qs = window.location.search.substr(1);
  const hash = window.location.hash.substr(1);
  const parsedQueryParams = decode(qs);

  if (value) {
    parsedQueryParams[key] = value;
  } else {
    delete parsedQueryParams[key];
  }

  const newQueryParams = encode(parsedQueryParams);
  window.realReplaceState(null, null, "" + window.location.pathname + (newQueryParams ? "?" + newQueryParams : '') + (hash ? "#" + hash : ''));
};
/**
 * Checks whether a cookie value has been set
 * If it has, uses the `updateQueryString` utility to set a key/value pair
 * on the URL's query string
 * Finally, deletes the cookie value
 */

const convertCookieValToQueryString = key => {
  // Check whether a specific key / value has been set in a cookie
  const cookieValue = Cookies.get(key);

  if (typeof cookieValue !== 'undefined') {
    updateQueryString(key, cookieValue); // Clean up cookies

    Cookies.remove(key);
  }
};

export { appendQueryStringToURL as a, convertCookieValToQueryString as c, updateQueryString as u };
